module.exports = __webpack_public_path__ + "img/good_casper_black.1e745722.svg";